import React, { useState, useEffect } from 'react'
import './style.css'
import JwPagination from 'jw-react-pagination'
import SelectedItems from '../SelectedItems'
import { useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
} from '@fortawesome/free-solid-svg-icons'
import Search from '../Search' // Adjust the import path based on your directory structure

const isChecked = (props, property, value) => {
  return props.mainProps[property].indexOf(value) !== -1
}

export default function AssignTabs(props) {
  const [items, setItems] = useState([])
  const [pageOfItems, setPageOfItems] = useState([])
  const [searchValue, setSearchValue] = useState('') // Added search state

  const dispatch = useDispatch()

  const onChangePage = (pageOfItems) => {
    setPageOfItems(pageOfItems)
  }

  useEffect(() => {
    if (props.enableCategories === -1) {
      props.setCurrentTab(
        'user',
        'selectedUsers',
        'users',
        'toggleUsers',
        'showSelectedUsers',
        'setShowSelectedUsers',
        'setHideSelectedUsers'
      )
    } else {
      props.setCurrentTab(
        'category',
        'selectedOrgGroups',
        'groupOrgs',
        'toggleOrgGroups',
        'showSelectedOrgGroups',
        'setShowSelectedOrgGroups',
        'setHideSelectedOrgGroups'
      )
    }
  }, [props.enableCategories, props.setCurrentTab])

  useEffect(() => {
    if (props.selectedItems === 'selectedUsers' && props.items.length) {
      setItems(props.items)
    }
  }, [props.selectedItems, props.items])

  // Update items based on search value
  useEffect(() => {
    if (props.selectedItems === 'selectedUsers') {
      const filteredItems = props.items.filter((item) =>
        `${item.first_name ? item.first_name.trim() : ''} ${
          item.last_name ? item.last_name.trim() : ''
        }`
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      )
      setItems(filteredItems)
    }
  }, [searchValue, props.items, props.selectedItems])

  const customLabels = {
    first: <FontAwesomeIcon icon={faAngleDoubleLeft} />,
    last: <FontAwesomeIcon icon={faAngleDoubleRight} />,
    previous: <FontAwesomeIcon icon={faAngleLeft} />,
    next: <FontAwesomeIcon icon={faAngleRight} />,
  }

  // Handle search input change
  const handleSearch = (e) => {
    setSearchValue(e.target.value)
  }

  return (
    <div className='assign-form-row assign-tab rounded'>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        {/* Show Selected Items Button */}
        {props.selectedItems === 'selectedUsers' && (
          <div className='show-selected-items'>
            <SelectedItems
              {...props}
              items={props.items.filter((item) =>
                props.mainProps[props.selectedItems].includes(item.id)
              )}
              selectedItems={props.selectedItems}
              showSelectedItems={props.showSelectedItems}
              hasDisabledProperty={false}
              isUsersSelect={props.selectedItems === 'selectedUsers'}
              onChange={props.toggleItem}
              setShowSelectedItems={() =>
                dispatch(props.setShowSelectedItems())
              }
              setHideSelectedItems={() =>
                dispatch(props.setHideSelectedItems())
              }
            />
          </div>
        )}

        {/* Search Component */}
        {props.selectedItems === 'selectedUsers' && (
          <div className='search-container'>
            <Search
              placeholder='Search users'
              value={searchValue}
              onChange={handleSearch}
            />
          </div>
        )}
      </div>

      {props.selectedItems === 'selectedUsers' && (
        <div
          style={{
            textAlign: 'center',
            marginTop: '10px',
            marginBottom: '10px',
          }}
        >
          <JwPagination
            pageSize={20}
            disableDefaultStyles={true}
            items={items}
            onChangePage={onChangePage}
            labels={customLabels}
          />
        </div>
      )}
      {props?.items?.length
        ? props.selectedItems === 'selectedUsers'
          ? pageOfItems.map((item, index) => (
              <div
                className='modules-options d-flex align-items-center justify-content-between'
                key={index}
              >
                <label>
                  <input
                    type='checkbox'
                    onChange={() => dispatch(props.toggleItem(item.id))}
                    checked={isChecked(props, props.selectedItems, item.id)}
                  />
                  <span>
                    {item.first_name} {item.last_name}
                  </span>
                </label>
                <span className='text-xs'>{item?.username}</span>
              </div>
            ))
          : props.items
              .filter((item) =>
                item.name
                  .toLowerCase()
                  .includes(props.assignSearchValue.toLowerCase())
              )
              .map((item, index) => (
                <div className='modules-options' key={index}>
                  {console.log(props, props.selectedItems, item.id, 'leart141')}

                  <label>
                    <input
                      type='checkbox'
                      onChange={() => dispatch(props.toggleItem(item.id))}
                      checked={isChecked(props, props.selectedItems, item.id)}
                    />
                    <span>{item.name}</span>
                  </label>
                </div>
              ))
        : null}
    </div>
  )
}
